import upperFirst from 'lodash/upperFirst';

import { PinnedProduct } from '@/forwarding/entities/PinnedItem/PinnedProduct';
import { BaseProductType, formatBaseProductTypeLabel } from '@/product/constants/productTypes';

export type PinnedProductsPair = [BaseProductType, PinnedProduct[]];

export function formatCompareTitle(productType: BaseProductType, productsCount: number): string {
  return `Compare ${productsCount} ${formatBaseProductTypeLabel(productsCount, productType)}`;
}

export function formatAddToCollectionTitle(productType: Nullable<BaseProductType>, productsCount: number): string {
  if (productType) {
    return `Add to ${upperFirst(formatBaseProductTypeLabel(1, productType))} Collection (${productsCount})`;
  }

  return `Add to Collection (${productsCount})`;
}
